import SiteLayout from "@/components/feature/SiteLayout";
import useSeo from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";
import { topics } from "@/mocks/topics";
import Hero from "@/pages/home/components/Hero";
import HotRankPreview from "@/pages/home/components/HotRankPreview";
import CategoryGrid from "@/pages/home/components/CategoryGrid";
import FeaturedTopics from "@/pages/home/components/FeaturedTopics";
import CommentWall from "@/pages/home/components/CommentWall";
import CommunitySection from "@/pages/home/components/CommunitySection";
import FaqSection from "@/pages/home/components/FaqSection";

export default function Home() {
  useSeo({
    title: "深夜吃瓜 - 深夜话题讨论圈 · 评论区热聊与观点碰撞聚集地",
    description:
      "深夜吃瓜是聚焦全网热话题的讨论社区，汇集评论区热聊、观点碰撞与互动交流。每个热门瓜都有专属讨论区，随时发表看法、围观他人观点，感受深夜吃瓜的集体狂欢。",
    keywords: "深夜吃瓜,话题,讨论,评论区,观点,互动,热聊",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: "深夜吃瓜 - 深夜话题讨论圈",
        description:
          "聚焦全网热话题的讨论社区，汇集评论区热聊、观点碰撞与互动交流，每个热门瓜都有专属讨论区。",
        inLanguage: "zh-CN",
        url: "https://banhuita.cn/",
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: {
            "@type": "Answer",
            text: faq.a,
          },
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "深夜吃瓜精选话题",
        itemListElement: topics.map((topic, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: topic.title,
          url: `https://banhuita.cn/topics/${topic.id}`,
        })),
      },
    ],
  });

  return (
    <SiteLayout fullBleedTop>
      <Hero />
      <HotRankPreview />
      <CategoryGrid />
      <FeaturedTopics />
      <CommentWall />
      <CommunitySection />
      <FaqSection />
    </SiteLayout>
  );
}